import { InjectionToken } from "@angular/core";
import { environment } from "../../../environments/environment";

/**
 * True in builds that ship only the released features
 * (`environment.hideBetaFeatures`, on in production and client-preview).
 * Anything behind `betaFeatureGuard` or `*twxBetaFeature` is unreachable there.
 * Injected rather than read from `environment` directly so specs can flip it.
 */
export const HIDE_BETA_FEATURES = new InjectionToken<boolean>(
  "HIDE_BETA_FEATURES",
  {
    providedIn: "root",
    factory: () => environment.hideBetaFeatures,
  },
);
